import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { useState } from "react";
import {
  faBan,
  faClose,
  faDownload,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { IMAGE_HOST } from "../../../server/config";
import { externalRedirectUrl } from "../../../pages/page-redirect";
import { FileUploader } from "react-drag-drop-files";
import { TextField } from "@mui/material";

function FileInput(props: {
  name?: string;
  multiple?: boolean;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  remoteValue?: string;
  dragOverLabel?: string;
  className?: string;
  types?: string[];
  onError?: (err: string) => void;
  maxSize?: number;
  onChange?: (files: File[]) => void;
  onDragging?: (dragOver: boolean) => void;
  style?: React.CSSProperties;
  helperText?: string;
}) {
  const [files, setFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  return (
    <div
      className={"file-input " + (props.className ?? "")}
      style={props.style}
    >
      <TextField
        InputProps={{
          style: { color: "transparent" },
          readOnly: true,
        }}
        helperText={props.helperText}
        sx={{
          position: "absolute",
          top: -2,
          bottom: props.helperText ? -20 : 1,
          left: 0,
          right: 0,
          cursor: "pointer",
          zIndex: 1,
          "& .MuiOutlinedInput-root": {
            flex: 1,
            "& fieldset": {
              borderStyle: "dashed",
            },
            "&:hover fieldset": {
              borderStyle: "dashed",
            },
            "&.Mui-focused fieldset": {
              borderStyle: "dashed",
            },
            "& input": {
              caretColor: "transparent",
            },
          },
        }}
        label={
          props.label !== undefined
            ? props.label + (props.required ?? false ? " *" : "")
            : undefined
        }
        value="+"
      />
      {props.remoteValue !== undefined && (
        <Link
          to={externalRedirectUrl(IMAGE_HOST + props.remoteValue)}
          className="primary button text"
          title={
            props.remoteValue === undefined
              ? "No file uploaded"
              : "Download uploaded"
          }
          style={{
            cursor: props.remoteValue === undefined ? "not-allowed" : "pointer",
            alignSelf: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "var(--gap-small)",
            marginLeft: "9px",
            zIndex: 2,
          }}
          onClick={(e) => {
            if (props.remoteValue === undefined) {
              e.preventDefault();
              return false;
            }
          }}
        >
          <FontAwesomeIcon
            icon={props.remoteValue !== undefined ? faDownload : faBan}
          />
        </Link>
      )}
      {isUploading || props.remoteValue === undefined ? (
        <FileUploader
          classes="control surface"
          name={props.name}
          multiple={props.multiple ?? false}
          required={props.required ?? false}
          disabled={props.disabled ?? false}
          hoverTitle={
            props.dragOverLabel ??
            "Încarcă " +
              (props.multiple ?? false ? "fișierele" : "fișierul") +
              " aici"
          }
          types={props.types}
          onTypeError={(err: any) => {
            if (props.onError) props.onError(err);
          }}
          maxSize={
            props.maxSize !== undefined
              ? props.maxSize / 1024 / 1024
              : props.maxSize
          }
          onSizeError={(err: any) => {
            if (props.onError) props.onError(err);
          }}
          handleChange={(files: File | FileList | File[]) => {
            if (files instanceof File) files = [files];
            if (files instanceof FileList) files = Array.from(files);
            setFiles(files);
            if (props.onChange) props.onChange(files);
          }}
          onDraggingStateChange={(dragOver: boolean) => {
            if (props.onDragging) props.onDragging(dragOver);
          }}
          dropMessageStyle={{
            border: "none",
            backgroundColor: "var(--color-dark)",
            color: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // overflow: "hidden",
            }}
          >
            <FontAwesomeIcon
              icon={faUpload}
              style={{ marginRight: "var(--gap-small)" }}
            />
            {files.length > 0
              ? files.reduce(
                  (prev, curr, index) =>
                    index === 0 ? prev : prev + ", " + curr.name,
                  files[0].name
                )
              : props.dragOverLabel ??
                "Încarcă " +
                  (props.multiple ?? false ? "fișierele" : "fișierul") +
                  " aici"}
          </div>
        </FileUploader>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            flex: 1,
            gap: "var(--gap-small)",
          }}
        >
          Încărcat!{" "}
          <button
            type="button"
            className="primary text button"
            onClick={() => setIsUploading(true)}
          >
            <FontAwesomeIcon
              icon={faUpload}
              style={{ marginRight: "var(--gap-small)" }}
            />
            {props.multiple ? "Încarcă altele" : "Încarcă altul"}
          </button>
        </div>
      )}
      <button
        type="button"
        className="primary button text"
        disabled={files.length === 0}
        onClick={(e) => {
          e.preventDefault();
          setFiles([]);
          if (props.onChange) props.onChange([]);
        }}
        style={{
          marginRight: "9px",
          padding: "var(--gap-small) calc(var(--gap-small) + 4px)",
        }}
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
    </div>
  );
}

export default FileInput;
